export default "__VITE_ASSET__DB8MpCP$__"